export const xmlToJson = (xml: Element | Node) => {
  let obj: unknown = {};

  if (xml.nodeType === 1) {
    if ((xml as Element).attributes.length > 0) {
      obj = { attributes: {} } as Element;
      for (let i = 0; i < (xml as Element).attributes.length; i += 1) {
        const attribute = (xml as Element).attributes.item(i);
        if (attribute) {
          (obj as Element).attributes[attribute.nodeName] = attribute.nodeValue;
        }
      }
    }
  }

  if (xml.hasChildNodes()) {
    for (let i = 0; i < xml.childNodes.length; i++) {
      const item = xml.childNodes.item(i);
      const { nodeName } = item;
      if (typeof (obj as ChildNode)[nodeName] === 'undefined') {
        (obj as ChildNode)[nodeName] = xmlToJson(item);
      } else {
        if (!Array.isArray((obj as ChildNode)[nodeName])) {
          const currentNode = (obj as ChildNode)[nodeName];
          (obj as ChildNode)[nodeName] = [];
          (obj as ChildNode)[nodeName].push(currentNode);
        }
        (obj as ChildNode)[nodeName].push(xmlToJson(item));
      }
    }
  }

  return obj;
};
